/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GroupIdentifierDto } from './GroupIdentifierDto';
import type { RuleRunDto } from './RuleRunDto';

export type CreateDatapointQualificationDto = {
    comment?: string | null;
    date: number;
    group?: GroupIdentifierDto;
    ruleRunDto: RuleRunDto;
    userAnomalyStatus?: CreateDatapointQualificationDto.userAnomalyStatus | null;
    userEvaluationStatus: CreateDatapointQualificationDto.userEvaluationStatus;
};

export namespace CreateDatapointQualificationDto {

    export enum userAnomalyStatus {
        ANOMALY = 'ANOMALY',
        NOT_ANOMALY = 'NOT_ANOMALY',
    }

    export enum userEvaluationStatus {
        PENDING = 'PENDING',
        REVIEWED = 'REVIEWED',
    }


}
